import { type FC } from 'react';
import {
  Gauge
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconGaugeProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconGauge: FC<UiIconGaugeProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Gauge}
      {...props}
    />
  );
};
